import * as React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { LoadingButton } from '@mui/lab'
import { modalConfirmData, modalConfirmVisible } from '../../../redux/reducers/modal-confirm/modal-confirm.selectors'
import { resetModalConfirm } from '../../../redux/reducers/modal-confirm/modal-confirm.actions'
import api from '../../../services/api'
import { showMessage } from '../../../redux/reducers/snackbar/snackbar.actions'
import { useState } from 'react'
import { setReloadTrainingWorkout } from '../../../redux/reducers/training-workout/training-workout.actions'

export const ModalConfirmation = () => {
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()

  const isVisible = useAppSelector(modalConfirmVisible)
  const data = useAppSelector(modalConfirmData)

  const onClose = () => {
    dispatch(resetModalConfirm())
  }

  const onSave = async () => {
    try {
      if (data) {
        setIsLoading(true)
        await api.delete(data?.url)
        dispatch(showMessage({ message: `${t('trainingWorkout.deleteWorkout_success')}` }))
        dispatch(resetModalConfirm())
        dispatch(setReloadTrainingWorkout())
      }
    } catch (e: any) {
      dispatch(showMessage({ message: `${t('general.error')}`, type: 'error' }))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Dialog
      open={isVisible}
      onClose={onClose}>
      <DialogTitle>{t('trainingWorkout.deleteWorkout_title')}</DialogTitle>
      <DialogContent>
        <Stack direction='row' marginTop={2} alignItems='center' sx={{ maxWidth: '100%', height: '50px' }}>
          <span>
            {`${t('trainingWorkout.deleteWorkout_messenger', { name: (typeof data?.reference === 'string' ? data?.reference : data?.reference) })}`}
          </span>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ height: '50px' }}>
        <LoadingButton loading={isLoading} onClick={onSave} variant="contained">
          {t('general.btn.confirm')}
        </LoadingButton>
        <Button onClick={onClose} variant="contained" color="secondary">{t('general.btn.dismiss')}</Button>
      </DialogActions>
    </Dialog>
  )
}
